import React, { useState, useEffect, useContext } from 'react';
import Carrier from '../../carrier';
import ModalModule from '../../modal';
import Terms from '../../terms';

const { Util } = Carrier;
const { Modal, ModalContext } = ModalModule;
const { TermsDialog } = Terms;

const CarrierStatementsModal = ({ modalId }) => {
	const [showUspsPrivacyModal, setShowUspsPrivacyModal] = useState(false);
	const [showUpsShippingModal, setShowUpsShippingModal] = useState(false);
	const { closeModal, showModal } = useContext(ModalContext);

	useEffect(() => {
		const carrierAgreements = Util.getCarrierAgreements();

		if ('USPS' in carrierAgreements) {
			setShowUspsPrivacyModal(true);
		}

		if ('UPS' in carrierAgreements) {
			setShowUpsShippingModal(true);
		}
	}, []);

	const closeCarrierStatements = () => {
		closeModal(modalId);
	};

	const launchUspsPrivacyModal = () => {
		showModal({
			component: TermsDialog,
			data: {
				termType: 'USPSPrivacyAct',
				hideFooter: true,
			},
		});
	};

	const launchUpsShippingModal = () => {
		showModal({
			component: TermsDialog,
			data: {
				termType: 'UPSIntShippingForms',
				hideFooter: true,
			},
		});
	};

	return (
		<Modal
			modalId={modalId}
			className="common-settings carrier-statements-modal"
			header="Carrier Statements"
			primaryButton={{
				text: 'Done',
				onClick: closeCarrierStatements,
			}}
		>
			<p>Click the links below to review the statements of your enabled carriers:</p>
			<ul className="carrier-terms-container">
				{showUspsPrivacyModal && (
					<li>
						<a role="link" tabIndex={0} onClick={launchUspsPrivacyModal}>
							USPS Privacy Act Statement
						</a>
					</li>
				)}
				{showUpsShippingModal && (
					<li>
						<a role="link" tabIndex={0} onClick={launchUpsShippingModal}>
							UPS International Shipping Forms Statement
						</a>
					</li>
				)}
			</ul>
		</Modal>
	);
};

export default CarrierStatementsModal;
